<template>
    <accordion-item>
        <h2 slot="header">
            Past Loss of Earnings &mdash; {{currencyFormat(value)}}
        </h2>
        <p>
            This head of loss is calculated using (i) your selected gross annual income (converted to net
            equivalent by the tool), and (ii) assumes loss of earnings from date of onset of symptoms to death.
            The period between death and assumed date of trial/settlement is discounted by Table E Factor. 
            The multiplier is applied from date of trial/assumed settlement but discounted by Table F Factor.
        </p>
    </accordion-item>
</template>

<script>
    import AccordionItem from "components/accordion/AccordionItem";
    import currencyFormat from "mixins/currencyFormat";

    export default {
        name: "past-loss-earnings-modal",
        components: {
            AccordionItem
        },
        mixins: [
            currencyFormat
        ],
        props: {
            value: {
                required: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PastLossEarningsModal.vue?7a42a1f2